import { MODULES } from '@core/constants/modules.contants';
import { useService } from '@policoders/di';
import Layout from '@shared/components/layout.component';
import { NavbarItem } from '@shared/components/navbar/navbar-item.model';
import NavbarService from '@shared/components/navbar/navbar.service';
import { Outlet } from 'react-router-dom';

export const MainLayout: React.FC = () => {
  const items: NavbarItem[] = [];
  const navbar = useService<NavbarService>('NavbarService');
  navbar.set({ module: MODULES.MAIN, navbar: items });
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};
